<template>
    <header v-text-align.center v-padding.top="2">
        <v-link>
            <v-logo black />
        </v-link>
        <div>
            <v-text type="subheadling">
                Набор онлайн-инструментов для успешного бизнеса кредитного брокера
            </v-text>
        </div>
    </header>
</template>
<script>
export default {
    name: 'header',
}
</script>



// WEBPACK FOOTER //
// Header.vue?66e824cc